// extracted by mini-css-extract-plugin
module.exports = {"containerInfo":"InfoPopup_containerInfo__1tNS4","errIcon":"InfoPopup_errIcon__qEeuc"};